var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-w",staticStyle:{"height":"100%","overflow":"auto"}},[_c('goods-data')],1)}
var staticRenderFns = []

export { render, staticRenderFns }